import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import PageHelmet from '../../components/PageHelmet';
import PageIntroBanner from '../../components/PageIntroBanner';
import MenuContact from '../../components/MenuContact';
import Form from '../../components/Forms/Form';

const styles = css`
  .Contact_wrapper {
    padding: 8vh 15px 0;
    display: flex;
    flex-direction: column;
    @media(min-width: 992px) {
      padding: 0 40px 20px;
    }

    .Contact_welcome {
      font-weight: 500;
      font-size: 21px;
      color: #545759;
      letter-spacing: 0.44px;
      line-height: 45px;
      @media(min-width: 992px) {
        font-weight: 300;
        font-size: 23px;
        line-height: 51px;
      }
    }
  }

  p {
    font-size: 19px;
    line-height: 42px;
    font-weight: 300;
    color: #545759;
    @media(min-width: 992px) {
      font-size: 23px;
      line-height: 51px;
    }
  }

  .ButtonDark {
    padding-right: 0;
  }

  .Contact_wrapper, .Welcome_section {
    padding: 15px;
    max-width: 900px;
  }
  .Disclosures_copy {
    color: #545759 !important;
  }
`;

function ContactUs({ page }) {
  return (
    <PageWrapper>
      <PageHelmet page={page} />
      <InsideHeader
        h1={`${page.meta.name}`}
        background={get(page, 'page_image.contentUrl')}
      />
      <MenuContact />
      <div className={styles}>
        <PageIntroBanner
          headline={get(page, 'page_intro_banner[0].headline')}
          body={get(page, 'page_intro_banner[0].text')}
          image={get(page, 'page_intro_banner[0].photo.contentUrl')}
          videoThumbnail={get(page, 'page_intro_banner[0].video_thumbnail.contentUrl')}
          video={get(page, 'page_intro_banner[0].video_embed_code')}
        />
        <div className="container my-5 py-5">
          <div className="row">
            <div className="col-lg-8 mx-lg-auto">
              <Form
                formName="contactUs"
                formLabel="Contact Us"
                fields={[
                  {
                    type: 'Text',
                    label: 'First Name',
                    className: 'form-col',
                    field: 'firstName',
                    required: true,
                  },
                  {
                    type: 'Text',
                    label: 'Last Name',
                    className: 'form-col',
                    field: 'lastName',
                    required: true,
                  },
                  {
                    type: 'Email',
                    label: 'Email Address',
                    className: 'form-col',
                    field: 'email',
                    required: true,
                    requiredMessage: '',
                    invalidMessage: '',
                  },
                  {
                    type: 'Phone',
                    label: 'Phone',
                    className: 'form-col',
                    field: 'phone',
                    required: false,
                    requiredMessage: '',
                    invalidMessage: '',
                  },
                  {
                    type: 'CommunitySelect',
                    label: 'Community of Interest',
                    className: 'form-col',
                    field: 'community',
                    required: false,
                    requiredMessage: '',
                    invalidMessage: '',
                  },
                  {
                    type: 'Text',
                    label: 'Price Range',
                    className: 'form-col',
                    field: 'priceRange',
                    required: false,
                  },
                  // {
                  //   type: 'TextArea',
                  //   label: 'Comments/Questions',
                  //   className: 'form-col-fluid',
                  //   placeholder: 'How can we help you?',
                  //   field: 'comments',
                  //   required: true,
                  // },
                  // {
                  //   type: 'FileMultiple',
                  //   label: 'Attach Images (max 5)',
                  //   className: 'form-col-fluid',
                  //   field: 'files',
                  //   max: 5,
                  //   required: false,
                  // },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}

ContactUs.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData(
  {
    page: 'contact_us',
  },
  {
    ifMissing404: true,
  },
)(ContactUs);



// WEBPACK FOOTER //
// ./src/pages/ContactUs/index.js